import React from 'react';
import Masonry from 'react-masonry-css';
import Pin from './Pin';
import Conversation from './Conversation';
import Vid from './Posts/Vid';

const breakpointColumnsObj = {
  default: 4,
  1200: 3,
  1000: 2,
  500: 1,
};

const MasonryLayout = ({ pins }) => (
  <Masonry className="flex animate-slide-fwd" breakpointCols={breakpointColumnsObj}>
    {pins?.map((pin) =>
      pin?._type === "pin" 
      ? 
        <Pin key={pin._id} pin={pin} className="w-max" /> 
      : 
        (
          pin?._type === "conversation" 
        ? 
          <Conversation key={pin._id} conversation={pin} className="w-max" /> 
        : 
          <Vid key={pin._id} vid={pin} />
        )
    )}
    {/* {pins?.map((pin) => <Pin key={pin._id} pin={pin} className="w-max" />)} */}
    {/* {convos?.map((convo) => <Conversation key={convo._id} conversation={convo} className="w-max" />)} */}
  </Masonry>
);

export default MasonryLayout;